import Snackbar from '@/components/elements/notifications/Snackbar/Snackbar';
import { ROUTE_BUILDER } from '@/constants/pages';
import { _t } from '@/locale/i18n';
import { Place, PlaceService } from '@/types/state/shared';
import { toast } from 'react-toastify';
import { DealDetailItem } from '../../types/dealDetails';

/**
 * Returns a new Place with employees filtered to only those bookable for this deal.
 * Does not mutate the original.
 */
export function filterPlaceEmployees(place: Place, dealEmployees: { id: number }[]): Place {
  const dealEmployeeIds = dealEmployees.map((e) => e.id);
  const bookableEmployees = (place.employees || []).filter((employee) => dealEmployeeIds.includes(employee.id));

  return { ...place, employees: bookableEmployees };
}

export function showErrorToast() {
  toast(({ closeToast }) => <Snackbar label={_t('serverError')} onClose={closeToast} />);
}

export function getServiceDetails(place: Place, serviceId: number): PlaceService | undefined {
  return place.services.flatMap((service) => service.services).find((service) => service.id === serviceId);
}

export function getPlacePageUrl(data: DealDetailItem): string | null {
  if (!data) return null;
  const slug = data.place?.slug;
  const id = data.place?.id;

  if (!slug || !id) {
    return null;
  }

  return ROUTE_BUILDER.placePage(`${slug}-${id}`);
}
